<template>
  <div class="report-item-wrapper">
    <div class="report-item">
      <p>{{ statusText }}</p>
      <p>
        {{ `${job.appointmentNo}/${job.quantity}` }}
      </p>
      <p class="title">{{ job.service.name }}</p>
      <div class="user mt-2">
        <div class="item">
          <img :src="'/static/icons/supplier-icon/user-icon.svg'" />
          <p>{{ job.home.contact.name }}</p>
        </div>
        <div class="item">
          <img :src="'/static/icons/supplier-icon/tel-icon.svg'" />
          <p>{{ job.home.contact.phoneNumber }}</p>
        </div>
      </div>
      <div class="appointment">
        <div class="item">
          <img :src="'/static/icons/supplier-icon/appointment-icon.svg'" />
          <p>
            {{ `${dateText} ${timeText}` }}
          </p>
        </div>
        <div class="item">
          <img :src="'/static/icons/supplier-icon/address-icon.svg'" />
          <p>{{ job.home.address }}</p>
        </div>
      </div>
      <div class="note">
        <p v-if="isMobile" class="title">{{ "หมายเหตุ" }}</p>
        <p>{{ job.note }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  toLocaleTH,
  getDurationAppointmentTimeText,
  getAppointmentTimeText,
} from "@/lib/dateTime"
import { DateTime } from "luxon"
import { mSize } from "../StaticVariable"

export default {
  props: {
    job: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      type: this.$route.params.type,
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < mSize
    },
    dateTimeTH() {
      if (!this.job.dateTime) return null
      return toLocaleTH(DateTime.fromISO(this.job.dateTime))
    },
    dateText() {
      return this.dateTimeTH.toFormat("dd MMM yyyy")
    },
    timeText() {
      const appointmentDurationTime = getDurationAppointmentTimeText(
        this.job.dateTime || null,
        this.job.dateTimeEnd || null,
      )
      if (appointmentDurationTime) return appointmentDurationTime

      return getAppointmentTimeText(this.job.dateTime)
    },
    statusText() {
      const statusMap = {
        CREATED: "รอยืนยัน",
        CONFIRMED: "ยืนยันแล้ว",
        WAIT_CONFIRMED_SERVICE_COMPLETE: "รอดำเนินการ",
        PROVIDER_FULFILLED: "ปิดงานแล้ว",
      }

      return statusMap[this.job.status]
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
@import "~@/lib/scss/variables";
.report-item-wrapper {
  display: flex;
  flex-direction: column;

  > .report-item {
    display: grid;
    width: max-content;
    grid-template-columns: 130px 100px 250px 170px 280px 220px;
    grid-gap: 16px;
    align-items: center;
    padding: 12px 24px;
    border-bottom: 1px solid rgba(201, 201, 201, 0.3);
    color: $black;

    > .status {
      display: flex;
      flex-direction: row;
      align-items: center;
      grid-gap: 12px;
    }

    > .quantity {
      margin-top: -8px;
    }

    > .user {
      display: flex;
      flex-direction: column;
      grid-gap: 4px;

      > .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        grid-gap: 12px;
      }
    }

    > .appointment {
      display: flex;
      flex-direction: column;
      grid-gap: 4px;

      > .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        grid-gap: 12px;
      }
    }

    > .note {
      display: flex;
      flex-direction: column;

      > .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        grid-gap: 12px;
      }
    }
  }
}

p {
  font-size: $font-16;
  color: $black;
}

img {
  width: 20px;
}

@media (max-width: ($m-size - 1)) {
  .report-item-wrapper {
    display: flex;
    flex-direction: column;

    > .report-item {
      display: grid;
      width: max-content;
      grid-template-columns: 130px 100px 250px 170px 280px 220px;
      grid-gap: 16px;
      align-items: center;
      padding: 12px 24px;
      border-bottom: 1px solid rgba(201, 201, 201, 0.3);
      color: $black;
    }
  }
}
</style>
